import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"m22.713 1.4997-21.213 21.214\" fill=\"#fff\" /><path d=\"m22.713 1.4997-21.213 21.214\" stroke=\"#333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" /><path d=\"m22.713 22.7136-21.213-21.214\" fill=\"#fff\" /><path d=\"m22.713 22.7136-21.213-21.214\" stroke=\"#333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol